module.exports = new __parcel__URL__("info-background.8530c64d.png").toString();